import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('GameList').create(({ theme }) => ({
  listItem: {
    margin: '0',
    padding: '4px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    backgroundColor: theme.colors.button.secondary.background,
    border: `1px solid ${theme.colors.borders.secondary}`,
    borderRadius: '8px',
    height: '56px',
  },

  gameInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    gap: '12px',
  },
  gameIcon: {
    width: '120px',
    height: '56px',
    padding: '4px',
    img: {
      width: '100%',
      height: '100%',
      borderRadius: '8px',
      objectFit: 'fill',
    },
  },

  gameName: {
    width: '30vw',
    color: theme.colors.text.primary,
    fontWeight: '450',
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: theme.sizes.texts.lineHeight.m,

    fontFamily: 'Inter',

    p: {
      width: '100%',
      display: '-webkit-box',
      overflow: 'hidden',
      // '-webkit-box-orient': 'vertical',
      // '-webkit-line-clamp': '2',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: '2',
      margin: '0',
      padding: '0',
      textOverflow: 'ellipsis',
    },
  },

  gameTime: {
    paddingRight: '12px',
    display: 'flex',
    fontSize: '13px',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'end',
    color: theme.colors.text.secondary,
    width: '20%',
  },
}))
